"use client"

import { useEffect } from "react"
import { preventIosInputZoom } from "@/lib/prevent-ios-input-zoom"

/** iOS でテキスト入力 focus 時に画面が自動ズームされるのを防ぐ (詳細は lib/prevent-ios-input-zoom.ts) */
export function IosZoomFix() {
  useEffect(() => {
    preventIosInputZoom()
  }, [])
  return null
}
